const API_BASE_URL = 'https://darkslateblue-eel-151368.hostingersite.com/api';

// دالة للحصول على التوكن من localStorage
const getToken = () => {
  return localStorage.getItem('token');
};

// دالة عامة للتعامل مع الطلبات
const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = getToken();
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    };

    // إضافة التوكن إذا كان موجوداً
    if (token) {
      defaultOptions.headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, { ...defaultOptions, ...options });

    if (!response.ok) {
      // إذا كان الخطأ 401 (غير مصرح)، نمسح التوكن
      if (response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

// مقالات API
export const articlesAPI = {
  // الحصول على جميع المقالات
  getAll: () => apiRequest('/articles'),

  // الحصول على مقال واحد
  getOne: (id) => apiRequest(`/articles/${id}`),

  // إضافة مقال جديد
  create: (data) => apiRequest('/articles', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // تحديث مقال
  update: (id, data) => apiRequest(`/articles/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  // حذف مقال
  delete: (id) => apiRequest(`/articles/${id}`, {
    method: 'DELETE',
  }),

  // البحث والفلترة
  search: (query, category = 'الكل') => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    if (category && category !== 'الكل') params.append('category', category);
    
    return apiRequest(`/articles/search?${params.toString()}`);
  },
};

// استشارات API
export const consultationsAPI = {
  // الحصول على جميع الاستشارات
  getAll: () => apiRequest('/consultations'),

  // الحصول على استشارة واحدة
  getOne: (id) => apiRequest(`/consultations/${id}`),

  // إضافة استشارة جديدة
  create: (data) => apiRequest('/consultations', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // تحديث استشارة
  update: (id, data) => apiRequest(`/consultations/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  // حذف استشارة
  delete: (id) => apiRequest(`/consultations/${id}`, {
    method: 'DELETE',
  }),

  // البحث
  search: (query) => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    
    return apiRequest(`/consultations/search?${params.toString()}`);
  },
};

// مصادقة API
export const authAPI = {
  // تسجيل الدخول
  login: (credentials) => apiRequest('/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),

  // تسجيل الخروج
  logout: () => apiRequest('/logout', {
    method: 'POST',
  }),

  // التسجيل
  register: (data) => apiRequest('/register', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // الحصول على بيانات المستخدم
  getProfile: () => apiRequest('/profile'),
};

// إحصائيات API
export const statsAPI = {
  // الحصول على الإحصائيات
  getStats: () => apiRequest('/stats'),
};